'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchParcels = undefined;

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSinceActionAtTimestamp = function getSinceActionAtTimestamp() {
  var daysToQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 90;

  var prior = new Date(Date.now() - daysToQuery * 24 * 60 * 60 * 1000);
  return prior.valueOf();
};

var _cachedGet = void 0;

var fetchParcels = exports.fetchParcels = function fetchParcels() {
  if (_cachedGet) {
    return _cachedGet;
  }

  _cachedGet = _apiClient2.default.get('hubs/v2/parcels', {
    query: {
      sinceActionAt: getSinceActionAtTimestamp()
    }
  });

  return _cachedGet;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/api/parcelsApi.js
// module id = 480
// module chunks = 3 4 5